import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { IQueryEventParams, PagedEvents } from "@src/store/pricing/queryEventsSlice";

const initialState: PagedEvents = {
	itemCount: 0,
	Events: [],
};

export const { thunk: queryDuplicateListingEvents, slice: duplicateListingEventsSlice } = getThunkAndSlice<
	IQueryEventParams,
	PagedEvents
>({
	name: "duplicateListingEvents",
	initialState,
	path: "/api/Pricing/QueryEvents",
	method: "post",
});
